import React from "react";

const Dropdown = ({
  label,
  name,
  options,
  value,
  onChange,
  placeholderTitle,
}) => {
  return (
    <div className="mb-4">
      {label && (
        <label className="form-label fw-bold">{/* <h6>{label}</h6> */}</label>
      )}
      <select
        name={name}
        required
        value={value}
        onChange={onChange}
        className="form-select px-4"
        style={{
          borderRadius: "50px",
          width: "15rem",
          fontFamily: "Lato, sans-serif",
          color:"grey"
        }}
      >
        <option value="" disabled hidden>
          {placeholderTitle}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
